var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.statuses,"rules":_vm.filter ? [] : _vm.rules.status,"clearable":_vm.filter,"placeholder":_vm.filter ? 'All' : null,"hide-details":_vm.filter,"data-cy":'mv-status' + (_vm.filter ? '-filter' : ''),"label":"Status"},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }